module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><circle id=\"Oval\" cx=\"11\" cy=\"11\" r=\"5.10714286\"></circle></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_status_created_borderless.svg
// module id = ../../views/shared/icons/_icon_status_created_borderless.svg
// module chunks = commit_pipelines job_details pipelines pipelines_details vue_merge_request_widget